import { DocumentType } from 'src/models/enums/DocumentType.enum'

export interface IAuthorizationLogDTO {
  id: string
  createdDate: string
  authorizationType: DocumentType
  authorizationTypeString: string
  data: string
  createdBy: string
  createdByName: string
  scheduleId: string
  otAndPtCount?: number
  inHomePtCount?: number
  inpatientRehabCount?: number
  fceCount?: number
  conditioningAndHardeningCount?: number
  ptNote?: string
  quotedPtCount?: number
}

export class AuthorizationLogDTO implements IAuthorizationLogDTO {
  public id!: string
  public createdDate!: string
  authorizationType: DocumentType
  public authorizationTypeString!: string
  public data: string
  public createdBy!: string
  public createdByName!: string
  public scheduleId: string
  public otAndPtCount?: number
  public inHomePtCount?: number
  public inpatientRehabCount?: number
  public fceCount?: number
  public conditioningAndHardeningCount?: number
  public ptNote?: string
  public quotedPtCount?: number
  constructor(
    data: string,
    scheduleId: string,
    type: DocumentType,
    typeName?: string | undefined
  ) {
    this.data = data
    this.scheduleId = scheduleId
    this.authorizationType = type
    if (typeName !== undefined) {
      this.authorizationTypeString = typeName
    }
  }
}
